import { ChangeEventInterface } from '@/types/interfaces';
import Vue from 'vue';

const vueAppData = process.env.VUE_APP_DATA;
const moduleDecorators = require(`../../decorators/${vueAppData}Decorators/${vueAppData}ModuleDecorators`).default;
export const changeEventsModule = {
  moduleName: 'changeEventsModule',
  // The module name. eg. `'userItems'`
  // Can also be a nested module, eg. `'userModule/items'`
  statePropName: 'data',
  // The name of the property where the docs or doc will be synced to.
  // always best to set to `'data'` imo!
  // If left blank it will be synced on the state of the module.
  namespaced: true,
  // this is automatically added! See more info at: https://vuex.vuejs.org/guide/modules.html#namespacing
  // EVERYTHING BELOW IS OPTIONAL (only include what you use)
  // Related to the 2-way sync:
  sync: {
    where: [],
    orderBy: [],
    fillables: [],
    guard: [],
    defaultValues: {},
    debounceTimerMs: 1000,
    // HOOKS for local changes:
    insertHook(updateStore, doc, store) {
      return updateStore(doc);
    },
    patchHook(updateStore, doc, store) {
      return updateStore(doc);
    },
    deleteHook(updateStore, id, store) {
      return updateStore(id);
    },
    // for batches
    insertBatchHook(updateStore, docs, store) {
      return updateStore(docs);
    },
    patchBatchHook(updateStore, doc, ids, store) {
      return updateStore(doc, ids);
    },
    deleteBatchHook(updateStore, ids, store) {
      return updateStore(ids);
    },
  },
  // When docs on the server side are changed:
  serverChange: {
    convertTimestamps: {
      createdAt: '%convertTimestamp%',
    }, // HOOKS for changes on SERVER:
    addedHook(updateStore, doc, id, store) {
      return updateStore(doc);
    },
    modifiedHook(updateStore, doc, id, store) {
      return updateStore(doc);
    },
    removedHook(updateStore, doc, id, store) {
      return updateStore(doc);
    },
  },
  // When docs are fetched through `dispatch('module/fetch', filters)`.
  fetch: {
    // The max amount of documents to be fetched. Defaults to 50.
    docLimit: 50,
  },
  // You can also add custom state/getters/mutations/actions. These will be added to your module.
  state: {
    isDbChannelIsOpen: false,
  },
  getters: {
    // changeEventsSize: (state) => Object.keys(state.data).length,
    changeEvents: (state) => state.data,
    // changeEventsByArgumentId: (state) => (argumentId) =>
    //     Object.keys(state.data)
    //         .filter((key) => state.data[key].argumentId === argumentId)
    //         .map((id) => state.data[id])
    //         .sort((commentA: CommentInterface, commentB: CommentInterface) => commentA.createdAt.getTime() - commentB.createdAt.getTime()),
    // changeEventsBySectionId: (state) => (sectionId) =>
    //     Object.keys(state.data)
    //         .filter((key) => state.data[key].sectionId === sectionId)
    //         .map((id) => state.data[id])
    //         .sort((commentA: CommentInterface, commentB: CommentInterface) => commentA.createdAt.getTime() - commentB.createdAt.getTime()),
  },
  mutations: {
    setIsDbChannelIsOpen: (state) => {
      Vue.set(state, 'isDbChannelIsOpen', true);
    },
  },
  actions: {
    /**
     * adding comment
     * @param content
     * @param sectionId
     * @param argumentId
     */
    addChangeEvent: async (
      { context, rootGetters, dispatch, commit },
      { createdAt, type, subType, itemId, creator, content, parentItemId, documentId }: ChangeEventInterface
    ) => {
      const newChangeEvent: ChangeEventInterface = {
        createdAt,
        type,
        subType,
        itemId,
        parentItemId,
        documentId,
        documentLocale: rootGetters['documentsModule/documentLanguage'] || null,
        creator,
        content: content ?? null
      };
      console.log('newChangeEvent created: ', newChangeEvent)
      return await dispatch('insert', {
        ...newChangeEvent,
        documentId: rootGetters['documentsModule/documentId']
      });
    },
    deleteChangeEvent: async ({dispatch}, {id}) => {
      await dispatch('delete', id);
    }
  },
};
moduleDecorators['changeEventsModuleDecorator'](changeEventsModule);
